<div class="munily-apu-gallery">
  <input
    #fileInput
    type="file"
    class="munily-apu-gallery__file-input"
    [accept]="accept"
    [multiple]="multiple"
    tabindex="-1"
    (change)="onFilesSelected($event)"
  />

  <input
    #replaceInput
    type="file"
    class="munily-apu-gallery__file-input"
    [accept]="accept"
    [multiple]="false"
    tabindex="-1"
    (change)="onReplaceFileSelected($event)"
  />

  <!-- Subida siempre visible; miniaturas y huecos vacíos navegan en fila horizontal. -->
  <div class="munily-apu-gallery__trigger-slot">
    <button
      type="button"
      class="munily-apu-gallery__trigger"
      [ngClass]="triggerClasses"
      [disabled]="isUploadTriggerDisabled"
      [attr.aria-disabled]="isUploadTriggerDisabled || null"
      [attr.aria-label]="uploadLabelKey | translate"
      (click)="onUploadClick()"
    >
      <div class="munily-apu-gallery__trigger-inner">
        <mat-icon class="munily-apu-gallery__trigger-icon material-symbols-rounded" aria-hidden="true">upload</mat-icon>
        <span class="munily-apu-gallery__trigger-label">{{ uploadLabelKey | translate }}</span>
      </div>
    </button>
  </div>

  <div class="munily-apu-gallery__track-shell">
    <common-icon-button
      *ngIf="carouselNavigation === 'arrows' && canScrollPrev && !disabled"
      class="munily-apu-gallery__nav munily-apu-gallery__nav--left"
      variant="filled"
      color="weak"
      icon="chevron_left"
      [ariaLabel]="'commonComponents.areaPictureUploaderGallery.carouselPrev' | translate"
      [stopClickPropagation]="true"
      [iconPadding]="8"
      [backgroundOpacity]="1"
      (output)="onCarouselPrev()"
    ></common-icon-button>

    <div
      #scrollTrack
      class="munily-apu-gallery__track"
      [ngClass]="trackClasses"
      (scroll)="onTrackScroll()"
    >
      <!-- Sin CDK cuando no hay drag: evita listeners/overlays al cambiar de pestaña o subpaso. -->
      <ng-container *ngIf="dragDropEnabled; else galleryThumbsStatic">
        <div
          cdkDropList
          cdkDropListOrientation="horizontal"
          class="munily-apu-gallery__drop-list"
          [cdkDropListDisabled]="disabled"
          (cdkDropListDropped)="onGalleryDrop($event)"
        >
          <div
            *ngFor="let url of images; let i = index; trackBy: trackByImageUrl"
            class="munily-apu-gallery__thumb munily-apu-gallery__drag-item"
            cdkDrag
            [cdkDragDisabled]="disabled"
          >
            <common-area-picture-uploader
              [imageUrl]="url"
              [size]="size"
              [disabled]="disabled"
              [selected]="primaryIndex === i"
              [showReplaceOption]="false"
              [showSetPrimaryOption]="true"
              [showDeleteOption]="true"
              (menuAction)="onItemMenuAction(i, $event)"
            ></common-area-picture-uploader>
          </div>
        </div>
      </ng-container>

      <ng-template #galleryThumbsStatic>
        <div class="munily-apu-gallery__drop-list">
          <div
            *ngFor="let url of images; let i = index; trackBy: trackByImageUrl"
            class="munily-apu-gallery__thumb"
          >
            <common-area-picture-uploader
              [imageUrl]="url"
              [size]="size"
              [disabled]="disabled"
              [selected]="primaryIndex === i"
              [showReplaceOption]="false"
              [showSetPrimaryOption]="true"
              [showDeleteOption]="true"
              (menuAction)="onItemMenuAction(i, $event)"
            ></common-area-picture-uploader>
          </div>
        </div>
      </ng-template>

      <!-- Empty placeholder slots -->
      <div
        *ngFor="let _ of emptySlots; trackBy: trackByIndex"
        class="munily-apu-gallery__empty-slot munily-apu-gallery__thumb"
        [ngClass]="emptySlotClasses"
        aria-hidden="true"
      >
        <mat-icon class="munily-apu-gallery__empty-icon material-symbols-rounded" aria-hidden="true">image</mat-icon>
      </div>
    </div>

    <common-icon-button
      *ngIf="carouselNavigation === 'arrows' && canScrollNext && !disabled"
      class="munily-apu-gallery__nav munily-apu-gallery__nav--right"
      variant="filled"
      icon="chevron_right"
      color="weak"
      [ariaLabel]="'commonComponents.areaPictureUploaderGallery.carouselNext' | translate"
      [stopClickPropagation]="true"
      [iconPadding]="8"
      [backgroundOpacity]="1"
      (output)="onCarouselNext()"
    ></common-icon-button>
  </div>
</div>
